function FileBookshelfRepository() { }
FileBookshelfRepository.prototype.getHeaderMenuVisibility = async () => {
  return false;
};

export default new FileBookshelfRepository();